module.exports = __webpack_public_path__ + "img/di-3-fang_05.cc6d22ba.jpg";